import { render, staticRenderFns } from "./PdpTilesForBase.vue?vue&type=template&id=c42f28ea&scoped=true&"
import script from "./PdpTilesForBase.vue?vue&type=script&lang=js&"
export * from "./PdpTilesForBase.vue?vue&type=script&lang=js&"
import style0 from "./PdpTilesForBase.vue?vue&type=style&index=0&id=c42f28ea&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42f28ea",
  null
  
)

export default component.exports